/* eslint-disable @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766 */
import 'react-virtualized/styles.css';

import '@atlassian/jira-portfolio-3-common/src/css-variables/variables.css';

import './styles.module.css';

import '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/styles.css';

export { default } from './view/main';
